// extracted by mini-css-extract-plugin
export default {"emptySection":"styles_emptySection__4YiUr","icon":"styles_icon__+3TYw","heading":"styles_heading__S6okj","para":"styles_para__bDqYS"};